import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineArea extends TitleBase {
	private disciplineValue: string;
	private areaValue: string;
	private countryValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		this.areaValue = this.getFilterValue(ParameterType.AREA);
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);

		return (
			this.indexableFilters.length >= 3 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.AREA) &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in ${this.disciplineValue} in ${this.areaValue}, ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(
			`${this.titlePortalType} in the field of ${this.disciplineValue}`,
			` in ${this.areaValue}, ${this.countryValue}`
		);
	}
}
